import axiosClientFSR from "../axiosClientFSR"

export const configFrsUniview = {
    get: (params) => {
        return axiosClientFSR.get('config-univew', {
            params
        })
    },
    put: (params, data) => {
        return axiosClientFSR.put(`config-univew?camera_code=${params?.camera_code}`, data)
    },

}